module.exports = __webpack_public_path__ + "img/shift-fill.341e2d66.svg";